<template>
    <Main :logout="clearCredentials" :user="user" :company="company">
        <div class="pt-2 px-2">
            <div>
                <div class="w-full flex justify-between">
                    <div>
                        <h3 class="">Features</h3>
                    </div>
                    <div class="w-full flex justify-end">
                        <span class="text-sm font-bold capitalize" :class="{
                            'text-green-500': environment === 'live',
                            'text-blue-500': environment === 'staging',
                            'text-orange-600': environment === 'dev',
                            'text-pink-500': environment === 'local'
                        }">
                            {{ environment }}
                        </span>
                    </div>
                </div>
                <div class="flex gap-2 mb-1 text-sm">
                    <input type="checkbox" v-model="showOrders" />
                    <div>Bulk Order Management</div>
                </div>
                <div class="flex gap-2 mb-1 text-sm">
                    <input type="checkbox" v-model="showLiveData" />
                    <div>Live Market Data</div>
                </div>
            </div>
            <Orders class="border-t border-gray-600 py-2" v-if="showOrders" :company="company" :environment="environment"
                :environmentURL="environmentURL" :apiKey="apiKey" />
            <LiveData class="border-t border-gray-600 py-2" v-if="showLiveData" :company="company" :environment="environment"
                :environmentURL="environmentURL" :apiKey="apiKey" />
        </div>
    </Main>
</template>

<script setup>
import Main from '../layouts/Main.vue';
import LiveData from './LiveData.vue';
import Orders from './Orders.vue';

import { ref, onMounted } from 'vue';

const company = ref({});
const user = ref({});
const environment = ref("");
const environmentURL = ref("");
const apiKey = ref("");
async function loadCredentials() {
    user.value = JSON.parse(await OfficeRuntime.storage.getItem("user")) || {};
    company.value = JSON.parse(await OfficeRuntime.storage.getItem("company")) || {};
    apiKey.value = await OfficeRuntime.storage.getItem("apiKey");
    environment.value = await OfficeRuntime.storage.getItem("environment");
    environmentURL.value = await OfficeRuntime.storage.getItem("environmentURL");

    if (!user.value || !company.value || !apiKey.value || !environmentURL.value) {
        emit("MissingCredentials");
        return;
    }
}


const showOrders = ref(false);
const showLiveData = ref(false);
const emit = defineEmits(["MissingCredentials"]);
function clearCredentials() {
    OfficeRuntime.storage.removeItem("user");
    OfficeRuntime.storage.removeItem("company");
    OfficeRuntime.storage.removeItem("apiKey");
    user.value = {};
    company.value = {};
    apiKey.value = "";
    emit("MissingCredentials");
}

onMounted(async () => {
    await loadCredentials();
    if (user.value && company.value && apiKey.value) {
        showLiveData.value = true;
    }
});


</script>

<style scoped>
.base-page {
    padding: 24px;
}
</style>
